/* eslint-disable */
import { showDefaultErrorMessage } from '@/utils/createMessage'

import {
  SET_INVESTORS,
  ADD_INVESTOR,
  REMOVE_INVESTOR,
  SET_CURRENT_INVESTOR_ID,
  SET_CURRENT_INVESTOR
} from '@/store/mutationsTypes'
import { Message } from 'element-ui'
import Api from '@/repository/index'
const state = {
  investors: [],
  currentInvestor: {},
  currentInvestorId: null,

  investorTypes: [
    {
      label: 'Физ. лицо',
      value: 'fiz'
    },
    {
      label: 'ИП',
      value: 'ip'
    },
    {
      label: 'ООО',
      value: 'ooo'
    },
    {
      label: 'Самозанятость',
      value: 'slf'
    }
  ],

  dialogsVisible: {
    add: false,
    change: false,
    more: false
  }
}

const mutations = {
  SET_INVESTORS: (state, investors) => {
    state.investors = investors
  },

  ADD_INVESTOR: (state, investor) => {
    state.investors.push(investor)
  },

  REMOVE_INVESTOR: (state, id) => {
    const index = state.investors.findIndex(item => item.id === id)

    state.investors.splice(index, 1)
  },

  SET_CURRENT_INVESTOR_ID: (state, id) => {
    state.currentInvestorId = id
  },

  SET_CURRENT_INVESTOR: (state, investor) => {
    state.currentInvestor = investor
  },

  UPDATE_INVESTOR: (state, data) => {
    const index = state.investors.findIndex(item => item.id === data.id)

    state.investors.splice(index, 1, data)
  }

}

const actions = {
  async fetchInvestors ({ commit }) {
    try {
      const investors = await Api.parkManager.investors.getInvestors()
      commit(SET_INVESTORS, investors)

      return investors
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },

  async fetchInvestorById ({ commit }, id) {
    try {
      const investors = await Api.parkManager.investors.getInvestorById(id)
      commit(SET_CURRENT_INVESTOR, investors)
      return investors
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },

  async addInvestor ({ commit }, data) {
    try {
      const investors = await Api.parkManager.investors.createInvestor(data)
      commit(ADD_INVESTOR, investors)
      Message({
        message: 'Инвестор успешно создан!',
        type: 'success',
        duration: 5 * 1000
      })
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },

  async removeInvestor ({ commit }, id) {
    try {
      await Api.parkManager.investors.deleteInvestorById(id)
      commit(REMOVE_INVESTOR, id)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },

  async updateInvestor ({ commit, dispatch }, { id, data }) {
    try {
      await Api.parkManager.investors.updateInvestor(id, data)
      dispatch('fetchInvestors')
      Message({
        message: 'Инвестор успешно обновлен!',
        type: 'success',
        duration: 5 * 1000
      })
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    }
  },

  setCurrentInvestorId ({ commit }, id) {
    commit(SET_CURRENT_INVESTOR_ID, id)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
